import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { LayoutTemplateIcon, CodeIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
const FeatureList = ({
  items
}: {
  items: string[];
}) => <ul className="space-y-3 sm:space-y-4 mt-6 sm:mt-8" data-id="element-323">
    {items.map((item, idx) => <li key={idx} className="flex items-start gap-2 sm:gap-3" data-id="element-324">
        <div className="w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-325">
          <CheckIcon size={10} className="text-orange-600 sm:w-3 sm:h-3" data-id="element-326" />
        </div>
        <span className="text-gray-700 text-base sm:text-lg" data-id="element-327">{item}</span>
      </li>)}
  </ul>;
const CustomComponents = () => {
  return <section className="w-full bg-gradient-to-b from-white via-orange-50/20 to-white py-16 sm:py-24 md:py-32 lg:py-48" data-id="element-328">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-329">
        <div className="max-w-4xl mx-auto text-center mb-12 sm:mb-16 md:mb-20" data-id="element-330">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 tracking-tight leading-tight" data-id="element-331">
            Use ours — or build your own
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-332">
            FluidWeb isn't just a component library. It's a platform you can
            extend. Every component — ours or yours — runs on the same
            orchestration, policy, and audit layer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-10 md:gap-12 max-w-6xl mx-auto" data-id="element-333">
          {/* Drop-in Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-2xl sm:rounded-3xl border border-gray-200 p-6 sm:p-8 md:p-10 lg:p-12 shadow-sm" data-id="element-334">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-orange-50 rounded-xl sm:rounded-2xl flex items-center justify-center mb-6 sm:mb-8 text-orange-600" data-id="element-335">
              <LayoutTemplateIcon size={24} className="sm:w-7 sm:h-7" data-id="element-336" />
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-337">
              Drop-in components
            </h3>
            <p className="text-lg sm:text-xl text-gray-500 mb-6 sm:mb-8" data-id="element-338">
              Production-ready UI that handles the heavy lifting out of the box.
            </p>
            <div className="h-px w-full bg-gray-100 mb-6 sm:mb-8" data-id="element-339"></div>
            <FeatureList items={['Agentic Forms', 'Agentic Data Explorer', 'Agentic Navigation', 'Agentic Actions']} data-id="element-340" />
          </motion.div>

          {/* Custom Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 rounded-2xl sm:rounded-3xl border border-gray-200 p-6 sm:p-8 md:p-10 lg:p-12 shadow-sm" data-id="element-341">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-xl sm:rounded-2xl flex items-center justify-center mb-6 sm:mb-8 text-gray-900 shadow-sm border border-gray-100" data-id="element-342">
              <CodeIcon size={24} className="sm:w-7 sm:h-7" data-id="element-343" />
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4" data-id="element-344">
              Build custom
            </h3>
            <p className="text-lg sm:text-xl text-gray-500 mb-6 sm:mb-8" data-id="element-345">
              Full control over the UI, plugged into the same powerful engine.
            </p>
            <div className="h-px w-full bg-gray-200 mb-6 sm:mb-8" data-id="element-346"></div>
            <FeatureList items={['Bring your own UI & domain logic', 'Plug into the policy & execution layer', 'Define schemas once, reuse everywhere', 'Framework-agnostic React hooks']} data-id="element-347" />
          </motion.div>
        </div>

        <div className="mt-12 sm:mt-14 md:mt-16 text-center" data-id="element-348">
          <p className="text-base sm:text-lg text-gray-500 italic px-4" data-id="element-349">
            "Whether you use ours or build yours, the guardrails and reliability
            layer stays consistent."
          </p>
        </div>
      </div>
    </section>;
};
export default CustomComponents;